import {Box, Icon, Stack, Text} from "@mbank-design/design-system/components";
import {CalendarColor} from "@mbank-design/design-system/icons";
import moment from "moment";
import React from "react";

interface ConferenceDatesProps {
    conferenceDateFrom: Date;
    conferenceDateTo: Date;
}

export default function ConferenceDates({conferenceDateFrom, conferenceDateTo}: ConferenceDatesProps) {

    const formatDates = (): string => {
        const from: moment.Moment = moment(conferenceDateFrom);
        const to: moment.Moment = moment(conferenceDateTo);

        if (from.year() === to.year() && from.month() === to.month() && from.day() === to.day()) {
            return `${to.format('DD.MM.yyyy')}`;
        }
        else if (from.year() === to.year() && from.month() === to.month()) {
            return `${from.format('DD')}-${to.format('DD')}.${from.format('MM.yyyy')}`;
        }

        return `${from.format('DD.MM.yyyy')}-${to.format('DD.MM.yyyy')}`;
    }

    return(
        <Stack direction="row" alignY="flex-start">
            <Icon iconComponent={CalendarColor} size={24}/>
            <Box>
                <Text as={"small"} color={"doveGrayUI"}>
                    <>when?</>
                </Text>
                <Text>
                    {formatDates()}
                </Text>
            </Box>
        </Stack>
    );
}